(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('FaqCategoryDeleteController',FaqCategoryDeleteController);

    FaqCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'FaqManageService'];

    function FaqCategoryDeleteController($uibModalInstance, entity, FaqManageService) {
        var vm = this;

        vm.category = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FaqManageService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
